import React from "react";
import Address from "../../../../components/forms/userForms/userAddress/address";
import UserCanton from "../../../../components/forms/userForms/cantonAndCity/userCanton";
import UserCity from "../../../../components/forms/userForms/cantonAndCity/userCity";

export default function ThreePageForm() {
  return  <>
  <Address />
  <UserCanton />
  <UserCity />
</>
}
